// extracted by mini-css-extract-plugin
export default {"list":"AvailableGamesScreen_list__emzyk","skeletonList":"AvailableGamesScreen_skeletonList__u1dc+"};